export const SOLID_RENDER_ORDER = 0;
export const TRANSLUCENT_RENDER_ORDER = 1;
export const OVERLAY_RENDER_ORDER = 2;

export type OpacityMaterialProps = {
  transparent: boolean;
  opacity: number;
  depthWrite: boolean;
};

export function isTranslucent(opacity: number): boolean {
  return opacity < 1;
}

export function getOpacityMaterialProps(opacity: number): OpacityMaterialProps {
  return {
    transparent: true,
    opacity,
    depthWrite: !isTranslucent(opacity)
  };
}

export function getOpacityRenderOrder(opacity: number): number {
  return isTranslucent(opacity) ? TRANSLUCENT_RENDER_ORDER : SOLID_RENDER_ORDER;
}
